/**
 * Form UI stores nature_code as an object for a single input field.
 * API expects an array of additional item identification entries.
 */
export const toFormAdditionalItemIdentification = (value) => {
  if (!value) {
    return { nature_code: '' };
  }

  if (Array.isArray(value)) {
    const withNature = value.find((entry) => entry?.nature_code);

    return { nature_code: withNature?.nature_code ?? '' };
  }

  return {
    nature_code: value.nature_code ?? '',
  };
};

export const toApiAdditionalItemIdentification = (value) => {
  if (!value) {
    return null;
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? value : null;
  }

  const natureCode = value.nature_code;

  if (natureCode === null || natureCode === undefined || String(natureCode).trim() === '') {
    return null;
  }

  return [{ nature_code: String(natureCode) }];
};
